/**
 * Every third-party tag the captured site ran, with the IDs it used.
 *
 * The capture had 1,144 script tags spread across 61 pages, each page carrying
 * its own copy of the same five snippets inline in <head>. They are declared
 * once here and loaded by `loadAnalytics`.
 *
 * `category` drives consent: `essential` may run before a choice is made,
 * `analytics` and `marketing` may not.
 */
export type ConsentCategory = 'essential' | 'analytics' | 'marketing'

export interface TagConfig {
  id: string
  name: string
  category: ConsentCategory
  /** What it is, for the consent UI and for anyone auditing this file. */
  purpose: string
}

export const TAGS: TagConfig[] = [
  {
    id: 'G-3K4KLMDN1S',
    name: 'ga4',
    category: 'analytics',
    purpose: 'Google Analytics 4 — page views and traffic sources',
  },
  {
    id: '5096236',
    name: 'hotjar',
    category: 'analytics',
    purpose: 'Hotjar — session recordings and heatmaps',
  },
  {
    id: '1992858621458825',
    name: 'metaPixel',
    category: 'marketing',
    purpose: 'Meta Pixel — ad attribution',
  },
  {
    id: '45761690',
    name: 'hubspot',
    category: 'marketing',
    purpose: 'HubSpot — forms, chat, and contact tracking',
  },
  {
    id: '7604682',
    name: 'linkedin',
    category: 'marketing',
    purpose: 'LinkedIn Insight Tag — ad attribution and audience building',
  },
]

export const CONSENT_STORAGE_KEY = 'singulate.consent.v1'
